/**
 * Resolve rota pós-login com base em home_page e telas permitidas.
 */

import { isSuperadminUser } from './routingModePerfilFilter';

export function getScreenNameForRoute(route) {
  if (!route) return null;
  if (route.meta && route.meta.permissionScreen) {
    return route.meta.permissionScreen;
  }
  return route.name || null;
}

export function normalizePermissoesTelas(permissoes) {
  if (!Array.isArray(permissoes)) {
    return [];
  }
  return permissoes.filter((p) => p && p.nome_tela);
}

export function hasScreenPermission(permissoes, screenName) {
  if (!screenName || !Array.isArray(permissoes)) {
    return false;
  }
  return normalizePermissoesTelas(permissoes).some((p) => p.nome_tela === screenName);
}

export function canAccessScreen(user, permissoes, screenName) {
  if (!user || !screenName) {
    return false;
  }
  if (isSuperadminUser(user)) {
    return true;
  }
  return hasScreenPermission(permissoes, screenName);
}

export function getPermissionScreensForRoute(route) {
  if (!route) return [];
  const anyOf = route.meta && route.meta.permissionAnyOf;
  if (Array.isArray(anyOf) && anyOf.length > 0) {
    return anyOf.filter(Boolean);
  }
  const screenName = getScreenNameForRoute(route);
  return screenName ? [screenName] : [];
}

export function canAccessRoute(user, permissoes, route) {
  if (!user || !route) {
    return false;
  }
  if (isSuperadminUser(user)) {
    return true;
  }
  const screens = getPermissionScreensForRoute(route);
  if (screens.length === 0) {
    return false;
  }
  return screens.some((screenName) => canAccessScreen(user, permissoes, screenName));
}

export function canAccessPath(router, path, user, permissoes) {
  if (!path) {
    return false;
  }
  const resolved = router.resolve(path);
  const requiresAuth = resolved.route.matched.some((record) => record.meta.requiresAuth);
  if (!requiresAuth) {
    return true;
  }
  return canAccessRoute(user, permissoes, resolved.route);
}

export function findFirstPermittedPath(router, permissoes) {
  const telas = normalizePermissoesTelas(permissoes);
  if (telas.length === 0) {
    return null;
  }
  const authRoutes = router.options.routes.filter(
    (r) => r.meta && r.meta.requiresAuth && r.name && r.path
  );
  for (const permissao of telas) {
    const match = authRoutes.find((r) => {
      const screen = getScreenNameForRoute(r);
      return screen === permissao.nome_tela;
    });
    if (match) {
      return match.path;
    }
  }
  return null;
}

export function resolvePostLoginPath(router, homePage, user, permissoes) {
  const fallbackHome = homePage || '/operacao';
  if (isSuperadminUser(user)) {
    return fallbackHome;
  }
  if (canAccessPath(router, fallbackHome, user, permissoes)) {
    return fallbackHome;
  }
  return findFirstPermittedPath(router, permissoes);
}

export function storePermissoesTelas(permissoes) {
  const telas = normalizePermissoesTelas(permissoes);
  sessionStorage.setItem('permissoes', JSON.stringify(telas));
  return telas;
}
